import { render, staticRenderFns } from "./NodeScreen.vue?vue&type=template&id=67bf0b64&scoped=true"
import script from "./NodeScreen.vue?vue&type=script&lang=js"
export * from "./NodeScreen.vue?vue&type=script&lang=js"
import style0 from "./NodeScreen.vue?vue&type=style&index=0&id=67bf0b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf0b64",
  null
  
)

export default component.exports